<div class="page-container">
  <div class="page-header">
    <div>
      <h1 class="gradient-text">Заповненість паркувальних зон</h1>
      <p class="subtitle">Поточний статус паркувальних місць в реальному часі</p>
    </div>
  </div>

  <mat-card class="summary-card">
    <mat-card-content>
      <div class="summary">
        <div class="summary-item">
          <mat-icon>local_parking</mat-icon>
          <div>
            <h3>{{totalSpaces}}</h3>
            <p>Всього місць</p>
          </div>
        </div>
        <div class="summary-item">
          <mat-icon class="occupied">directions_car</mat-icon>
          <div>
            <h3>{{totalOccupied}}</h3>
            <p>Зайнято</p>
          </div>
        </div>
        <div class="summary-item">
          <mat-icon class="available">event_available</mat-icon>
          <div>
            <h3>{{totalSpaces - totalOccupied}}</h3>
            <p>Вільних</p>
          </div>
        </div>
        <div class="summary-item percentage">
          <div class="circular-progress">
            <span>{{getTotalOccupancyPercentage()}}%</span>
          </div>
          <p>Заповненість</p>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <div class="zones-grid">
    @for (zone of parkingZones; track zone.id) {
      <mat-card class="zone-card">
        <mat-card-content>
          <div class="zone-header">
            <div>
              <h3>{{zone.name}}</h3>
              <p class="zone-location">{{zone.level}} • {{zone.sector}}</p>
            </div>
            <mat-chip [style.background-color]="getStatusColor(zone.status) + '20'" 
                      [style.color]="getStatusColor(zone.status)">
              {{getStatusText(zone.status)}}
            </mat-chip>
          </div>

          <div class="zone-stats">
            <div class="stat">
              <mat-icon>local_parking</mat-icon>
              <div>
                <strong>{{zone.totalSpaces}}</strong>
                <span>всього</span>
              </div>
            </div>
            <div class="stat occupied">
              <mat-icon>directions_car</mat-icon>
              <div>
                <strong>{{zone.occupiedSpaces}}</strong>
                <span>зайнято</span>
              </div>
            </div>
            <div class="stat available">
              <mat-icon>event_available</mat-icon>
              <div>
                <strong>{{getAvailableSpaces(zone)}}</strong>
                <span>вільних</span>
              </div>
            </div>
          </div>

          <div class="progress-section">
            <div class="progress-header">
              <span>Заповненість</span>
              <strong>{{getOccupancyPercentage(zone)}}%</strong>
            </div>
            <mat-progress-bar 
              mode="determinate" 
              [value]="getOccupancyPercentage(zone)"
              [color]="zone.status === 'full' ? 'warn' : zone.status === 'almost-full' ? 'accent' : 'primary'">
            </mat-progress-bar>
          </div>
        </mat-card-content>
      </mat-card>
    }
  </div>
</div>
